import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a Competition Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form experiencePlatform='instagram' />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/competition/create/index.js